module.exports = __webpack_public_path__ + "static/img/vote_bg.e8da48e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/vote_bg.png
// module id = XfQH
// module chunks = 1